import { FormEvent } from "react";

import Button from "../../../../common/Button";

import {
  ButtonTypes,
  ButtonVariants,
} from "../../../../common/Button/constants";
import * as styledElements from "./PhysicalInventoryStyles";
import LoadingOverlay from "../../../../LoadingOverlay";

const ContainerFormButtons = ({
  onCancel,
  loading,
  isDisabled,
  submitButtonText = "Save",
  onSubmit,
}: {
  onCancel: () => void;
  loading: boolean;
  isDisabled: boolean;
  submitButtonText?: string;
  onSubmit?: (e?: FormEvent<HTMLFormElement>) => void;
}) => (
  <>
    <styledElements.ButtonArea>
      <Button
        label={"Cancel"}
        onClick={onCancel}
        variant={ButtonVariants.SECONDARY}
      />
      <Button
        label={submitButtonText}
        type={ButtonTypes.BUTTON}
        disabled={isDisabled}
        onClick={onSubmit}
      />
    </styledElements.ButtonArea>
    <LoadingOverlay loading={loading} text={"Saving"} />
  </>
);

export default ContainerFormButtons;
